import React from 'react';
import { Box } from '../Box/Box';
import { Text } from '../Text/Text';

export type StatSize = 'large' | 'small';

export interface StatProps {
  label: React.ReactNode;
  value: string;
  size?: StatSize;
}

export const Stat: React.FC<StatProps> = ({ label, value, size = 'large' }) => {
  return (
    <Box display="flex" flexDirection="column">
      <Text variant="smallCaps" mb="2">
        {label}
      </Text>

      <Text variant="tabular" fontSize={size === 'large' ? 'h2' : 'h4'} fontWeight={500}>
        {value}
      </Text>
    </Box>
  );
};
